import { useSelector } from 'react-redux';
import { appSelectors } from 'redux/ducks/app';
import { isFeatureEnabled } from 'services/feature-flag.service';
import { ConditionSection } from '..';
var FlagCondition = function (_a) {
    var falseStatement = _a.falseStatement, featureFlagName = _a.featureFlagName, trueStatement = _a.trueStatement;
    var featureFlags = useSelector(appSelectors.getFeatureFlags);
    var isFlagEnabled = isFeatureEnabled(featureFlags, featureFlagName);
    return (<ConditionSection condition={isFlagEnabled}>
      <ConditionSection.TrueStatement>{trueStatement}</ConditionSection.TrueStatement>
      <ConditionSection.FalseStatement>{falseStatement}</ConditionSection.FalseStatement>
    </ConditionSection>);
};
export default FlagCondition;
